<style lang="less" scoped>

</style>

<template>
  <div>
    <video
      ref="myVideo"
      controls
      width="100%"
      height="100%"
      :poster="poster"
      :disablePictureInPicture="true"
    >
    </video>
  </div>
</template>

<script>
const HLS = require('hls.js')
export default {
  name: 'tsVideo',
  props: {
    poster: {
      type: String,
      default: ''
    },
    vPath: {
      type: String,
      default: ''
    }
  },
  watch: {
    vPath (newval, oldval) {
      this.getStream(newval)
    }
  },
  mounted () {
    this.getStream(this.vPath)
  },
  data () {
    return {
      hls: null
    }
  },
  methods: {
    getStream (source) {
       console.log(source)
      if (HLS.isSupported()) {
        this.hls = new HLS()
        this.hls.loadSource(source)
        this.hls.attachMedia(this.$refs.myVideo) // this.$refs.myVideo
        this.hls.on(HLS.Events.MANIFEST_PARSED, () => {
          // this.$refs.myVideo.play()
        })
        this.hls.on(HLS.Events.ERROR, (event, data) => {
          this.$message.error('视频加载失败！')
        })
      }
    },
    vPause () {
      if (this.hls) {
        this.$refs.myVideo.pause()
        // this.hls.destroy()
        // this.hls = null
      }
    }
  }
}
</script>
